import type { PublishCourseDraft200Instructor } from './publishCourseDraft200Instructor';
import type { PublishCourseDraft200Level } from './publishCourseDraft200Level';
import type { PublishCourseDraft200Price } from './publishCourseDraft200Price';
import type { PublishCourseDraft200SectionsItem } from './publishCourseDraft200SectionsItem';

/**
 * 강의 정보 응답
 */
export type PublishCourseDraft200 = {
  createdAt?: string;
  description?: string;
  /** 강의 ID (초안 ID는 string일 수 있음) */
  id: string;
  /** 기본 사용자 정보 */
  instructor?: PublishCourseDraft200Instructor;
  isPremium?: boolean;
  isPublished?: boolean;
  /** @nullable */
  level?: PublishCourseDraft200Level;
  price?: PublishCourseDraft200Price;
  /**
   * 강의 커리큘럼 섹션 목록 (상세 정보 포함)
   * @nullable
   */
  sections?: PublishCourseDraft200SectionsItem[] | null;
  /** @nullable */
  thumbnailUrl?: string | null;
  title: string;
  updatedAt?: string;
};
